module.exports = __webpack_public_path__ + "img/DAVID_CANNON_08.f77d69f3.gif";